import axios from 'axios';
import router from "@/router/index";

const BASE_URL = process.env.VUE_APP_API_URL + "/";
const API_URL = BASE_URL + "api/";

class AuthService {
    login(user) {
        return axios
            .post(BASE_URL + 'authentication_token', {
                email: user.email.trim(),
                password: user.password.trim()
            })
            .then(response => {
                if (response.data.token) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }
                return response.data;
            })
            .catch(function (error) {
                if (error.response.data && error.response.data.code == '401') {
                    if (error.response.data) {
                        throw error.response.data.message
                    }
                } else {
                    alert("API Indisponible " + method);
                }

                throw error;
            });
    }

    logout() {
        localStorage.removeItem('user');
        router.push({name: 'public-login'});
    }

    checkError(error, method) {
        if (error.response === undefined) {
            alert("API Indisponible " + method + " [4001]");
        }
        if (error.response.status === undefined) {
            alert("API Indisponible " + method + " [4002]");
        } else if (error.response.status == '401' || error.response.status == '403') {
            alert("Vous avez été déconnecté, merci de vous reconnecter à nouveau.");
            this.logout()
            localStorage.removeItem('user')
            router.push({name: 'public-login'})
        } else if (method == 'getDashboardContent' || method == 'getCandidacyByUser') {
            let msg = "Votre compte utilisateur est en cours de création. \nVeuillez vous reconnecter dans quelques secondes.";
            if (error.response.data && error.response.data.message && 'NoDataFoundException' === error.response.data.message) {
                msg = "Votre compte a été désactivé. \nVeuillez en recréer un nouveau.";

            }
            alert(msg);
            this.logout()
            localStorage.removeItem('user')
            router.push({name: 'public-login'})
        } else {
            alert("API Indisponible " + method + " [4004]");
        }
    }

    register(candidacy) {
        return axios
            .post(API_URL + 'public/signup', {
                address: candidacy.address.trim(),
                birth_department: candidacy.birth_department.trim(),
                birthday: candidacy.birthday.trim(),
                birthplace: candidacy.birthplace.trim(),
                birthCityId: candidacy.birth_city_id ? candidacy.birth_city_id : '',
                city: candidacy.city.trim(),
                civility: candidacy.civility.trim(),
                email: candidacy.email.trim(),
                firstname: candidacy.firstname.trim(),
                marriedname: candidacy.marriedname ? candidacy.marriedname.trim() : '',
                lastname: candidacy.lastname.trim(),
                nationality: candidacy.nationality.trim(),
                password: candidacy.password.trim(),
                password2: candidacy.password2.trim(),
                phone_number: candidacy.phone_number.trim(),
                username: candidacy.email.trim()
            })
            .then(response => {
                return response;
            })
            .catch(function (error) {
                this.checkError(error, "login");
                throw error;
            });
    }
}

export default new AuthService();
